import type { PaginatedCollection } from "../resources/paginatedCollection";
import type { ResourceWithSlug } from "./ResourceWithSlug";
import type { PhaseResource } from "./phaseResource";
import type { ResourceWithId } from "./resource";
import type { RetentionPeriod } from "./retentionPeriod";
interface LifecycleResourceLinks {
    Self: string;
    Preview: string;
    Projects: string;
}
export interface LifecycleResource extends ResourceWithId<LifecycleResourceLinks>, ResourceWithSlug {
    SpaceId: string;
    Phases: PhaseResource[];
    Name: string;
    ReleaseRetentionPolicy: RetentionPeriod;
    TentacleRetentionPolicy: RetentionPeriod;
    Description?: string;
}
export interface LifecycleV2ResourceBase {
    Id: string;
    Slug: string;
    SpaceId: string;
    Name: string;
    ReleaseRetentionPolicy: RetentionPeriod;
    TentacleRetentionPolicy: RetentionPeriod;
    Description?: string;
    Type: string;
}
export interface ProgressionLifcycleV2Resource extends LifecycleV2ResourceBase {
    Phases: PhaseResource[];
    Type: "Progression";
}
export interface EphemeralEnvironmentLifcycleV2Resource extends LifecycleV2ResourceBase {
    ParentEnvironmentId: string;
    Type: "EphemeralEnvironment";
}
export type LifecycleV2Resource = ProgressionLifcycleV2Resource | EphemeralEnvironmentLifcycleV2Resource;
export interface GetLifecyclesV2Response {
    Lifecycles: PaginatedCollection<LifecycleV2Resource>;
}
export function mapFromLifecycleResourceToLifeycleV2Resource(lifecycle: LifecycleResource): LifecycleV2Resource {
    return {
        ...lifecycle,
        Type: "Progression",
        Slug: lifecycle.Slug ?? "",
    };
}
